import { apiSlice } from 'store/api/apiSlice';

// ───────────────────────────────────────────────────────────
// Types
// ───────────────────────────────────────────────────────────
export interface DesignationItem {
  IndexId: string;
  userType: string;
  userType1: string;
  geoType: 'state' | 'district' | 'block' | 'cluster' | 'school';
}

export interface DistrictItem {
  id: string | number;
  district_name: string;
}

export interface BlockItem {
  BlkId: string | number;
  BlkName: string;
}

export interface UserIdItem {
  teacher_id: string;
  teacherName: string; // aliased as teacherName in PHP SQL (teacher_name)
  teacher_type: string;
  type_teacher: string;
}

export interface GetUserIdRequest {
  usrType: string;
  usrType1: string;
  dis: string | number | null;
  blk: string | number | null;
}

export interface PostLoginLogRequest {
  records: {
    IndexId: string;
    userId: string;
    device: string;
    deviceDetails: string;
    ipAddress: string;
    type: 'in';
    time: string;
    toUserId: string;
  };
}

export interface SsoLoginRequest {
  records: {
    emis_username: string;
    type: number;
  };
}

// ───────────────────────────────────────────────────────────
export const multiLoginApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET https://webapistage.tnsed.com/api/tnemis/getAllUsrCatgry
    getDesignationList: builder.query<
      { dataStatus: boolean; result: DesignationItem[] },
      void
    >({
      query: () => ({
        url: 'getAllUsrCatgry',
        method: 'GET',
        service: 'djangoTnEmis',
      }),
    }),

    // GET https://webapistage.tnsed.com/api/tnemis/alldistrictlist

    getAllDistrictList: builder.query<
      { dataStatus: boolean; result: { schooldist: DistrictItem[] } },
      void
    >({
      query: () => ({
        url: 'alldistrictlist',
        method: 'GET',
        service: 'djangoTnEmis',
      }),
    }),

    getBlockByDistrict: builder.query<
      { dataStatus: boolean; result: BlockItem[] },
      string | number
    >({
      query: (districtId) => ({
        url: `api/allblocknameU?districtId=${districtId}`,
        method: 'GET',
        service: 'php3',
      }),
    }),

    getUserIdList: builder.query<
      { dataStatus: boolean; result: UserIdItem[] },
      GetUserIdRequest
    >({
      query: (req) => ({
        url: `getUsrIdByDes?usrTpe=${req.usrType}&usrTpe1=${req.usrType1}&dis=${req.dis ?? ''}&blk=${req.blk ?? ''}`,
        method: 'GET',
        service: 'djangoTnEmis',
      }),
    }),

    postLoginLog: builder.mutation<
      { dataStatus: boolean },
      PostLoginLogRequest
    >({
      query: (body) => ({
        url: 'postLoginLog',
        method: 'POST',
        body,
        service: 'djangoTnEmis',
      }),
    }),

    multiUserLogin: builder.mutation<any, { username: string }>({
      query: ({ username }) => ({
        url: 'testnewlogin',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   Accept: 'application/json',
        //   Authorization: 'EMIS@2019_api',
        //   Token: '',
        // },
        body: {
          records: {
            emis_username: username,
            emis_password: '',
            switch: '1',
          },
        },
        service: 'emis_login',
      }),
    }),

    ssoLogin: builder.mutation<
      { records?: { user_login_url?: string }; message?: string },
      SsoLoginRequest
    >({
      query: (body) => ({
        url: 'sso_login',
        method: 'POST',
        body,
        service: 'emis_login',
      }),
    }),
  }),
});

export const {
  useLazyGetDesignationListQuery,
  useLazyGetAllDistrictListQuery,
  useLazyGetBlockByDistrictQuery,
  useLazyGetUserIdListQuery,
  usePostLoginLogMutation,
  useMultiUserLoginMutation,
  useSsoLoginMutation,
} = multiLoginApi;
